module.exports = __webpack_public_path__ + "img/warning.26e76f45.png";